/* import __COLOCATED_TEMPLATE__ from './company.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export type TabName = 'mappings' | 'settings';

export interface Args {
  integrationCode: string;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class Company extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked selectedTab: TabName = 'mappings';

  @action setSelectedTab(tab: TabName) {
    this.selectedTab = tab;
  }

  translation = (path: string) => this.intl.t(this.translationKey(path));
  private translationKey = (path: string) =>
    `new-settings.data.imports-exports.import-zendesk.config-import-page.sections.company.${path}`;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Data::ImportsExports::ImportZendesk::ConfigImport::Sections::Company': typeof Company;
    'new-settings/data/imports-exports/import-zendesk/config-import/sections/company': typeof Company;
  }
}
